<template>
  <div class="modal animated is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-large">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="error !== ''">{{ error }}</div>
        <p class="control">
          <label class="label">Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('name'), 'is-disabled': inProgress}" type="text" name="name" id="name" placeholder="Name" v-model="hotel.name" disabled>
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
        <p class="control">
          <label class="label">EZConnect ID</label>
          <input :class="{'input': true, 'is-danger': errors.has('ezconnect_id'), 'is-disabled': inProgress}" type="text" name="ezconnect_id" id="ezconnect_id" placeholder="EZConnect ID" v-model="hotel.api_hotel_id" disabled>
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('ezconnect_id') }}</span>
        </p>
        <p class="control">
          <label class="label">Hotelier</label>
          <v-select
            @search="getChains"
            :options="chains"
            placeholder="Search a Hotelier"
            label="name"
            max-height="200px"
            v-model="chain"
          >
          </v-select>
        </p>
        <p class="control">
          <label class="label">Chain</label>
          <v-select
            @search="getChainsHotel"
            :options="chains_hotel"
            placeholder="Search a Chain"
            label="name"
            max-height="200px"
            v-model="chain_hotel"
          >
          </v-select>
        </p>
        <p class="control">
          <label class="label">Email</label>
          <input :class="{'input': true, 'is-disabled': inProgress}" type="email" name="email" id="email" placeholder="Email" v-model="hotel.email">
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
        </p>
        <p class="control">
          <label class="label">Social Reason</label>
          <input :class="{'input': true, 'is-danger': errors.has('social_reason'), 'is-disabled': inProgress}" type="text" name="social_reason" id="social_reason" placeholder="Social Reason" v-model.trim="hotel.social_reason" v-validate="'required|min:5'">
          <span v-show="errors.has('social_reason')" class="help is-danger">{{ errors.first('social_reason') }}</span>
        </p>
        <template v-if="parseInt(hotel.country_id) === 24">
          <p class="control">
            <label class="label">CNPJ</label>
            <input :class="{'input': true, 'is-danger': errors.has('cnpj'), 'is-disabled': inProgress}" type="text" name="cnpj" id="cnpj" placeholder="CNPJ" v-model.trim="hotel.cnpj" v-validate="'required|cnpj'">
            <span v-show="errors.has('cnpj')" class="help is-danger">{{ errors.first('cnpj') }}</span>
          </p>
        </template v-else>
          <p class="control">
            <label class="label">CNPJ</label>
            <input :class="{'input': true, 'is-danger': errors.has('cnpj'), 'is-disabled': inProgress}" type="text" name="cnpj" id="cnpj" placeholder="CNPJ" v-model.trim="hotel.cnpj">
            <span v-show="errors.has('cnpj')" class="help is-danger">{{ errors.first('cnpj') }}</span>
          </p>
        <template>

        </template>
        <p class="control">
          <label class="label">Credit Card Statement Name</label>
          <input :class="{'input': true, 'is-danger': errors.has('card_statement_name'), 'is-disabled': inProgress}" type="text" name="card_statement_name" id="card_statement_name" placeholder="Nome que aparece na fatura do cartão" v-model.trim="hotel.card_statement_name">
          <span v-show="errors.has('card_statement_name')" class="help is-danger">{{ errors.first('card_statement_name') }}</span>
        </p>
        <p class="control">
          <label class="label">Financial Email</label>
          <input :class="{'input': true, 'is-danger': errors.has('financial_email'), 'is-disabled': inProgress}" type="email" name="financial_email" id="financial_email" placeholder="Email" v-model="hotel.financial_email">
          <span v-show="errors.has('financial_email')" class="help is-danger">{{ errors.first('financial_email') }}</span>
        </p>
        <p class="control">
          <label class="label">Receipt Email</label>
          <input :class="{'input': true, 'is-danger': errors.has('receipt_email'), 'is-disabled': inProgress}" type="email" name="receipt_email" id="receipt_email" placeholder="Email" v-model="hotel.receipt_email" v-validate="'email'">
          <span v-show="errors.has('receipt_email')" class="help is-danger">{{ errors.first('receipt_email') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Phone</label>
          <input :class="{'input': true, 'is-danger': errors.has('phone'), 'is-disabled': inProgress}" type="text" name="phone" id="phone" placeholder="Phone" v-model="hotel.phone" v-validate="'required|min:7'">
          <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Location</label>
          <input :class="{'input': true, 'is-danger': errors.has('location'), 'is-disabled': inProgress}" type="text" name="location" id="location" placeholder="Location" v-model="hotel.location" disabled>
          <span v-show="errors.has('location')" class="help is-danger">{{ errors.first('location') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Country</label>
          <input :class="{'input': true, 'is-danger': errors.has('country'), 'is-disabled': inProgress}" type="text" name="country" id="country" placeholder="Country" v-model="hotel.country.name" disabled>
          <span v-show="errors.has('country')" class="help is-danger">{{ errors.first('country') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Address</label>
          <input :class="{'input': true, 'is-danger': errors.has('address'), 'is-disabled': inProgress}" type="text" name="address" id="address" placeholder="Address" v-model="hotel.address" disabled>
          <span v-show="errors.has('address')" class="help is-danger">{{ errors.first('address') }}</span>
        </p>
        <p class="control is-expanded">
          <label class="label">Payment Information</label>
          <textarea :class="{'textarea': true, 'is-danger': errors.has('payment_information')}" name="payment_information" id="payment_information" placeholder="Payment Information" v-model="hotel.payment_information"></textarea>
          <span v-show="errors.has('payment_information')" class="help is-danger">{{ errors.first('payment_information') }}</span>
        </p>
        <p class="control">
          <label class="label">Markup</label>
          <input :class="{'input': true, 'is-danger': errors.has('markup'), 'is-disabled': inProgress}" type="text" name="markup" id="markup" placeholder="0.0" v-model="hotel.markup" v-validate="'decimal:3'">
          <span v-show="errors.has('markup')" class="help is-danger">{{ errors.first('cnpj') }}</span>
        </p>
      </section>
      <footer class="modal-card-foot">
        <div class="control is-grouped is-pulled-right">
          <p class="control is-pulled-right">
            <a :class="{'button': true, 'is-primary': true, 'is-disabled': inProgress }" @click="close(true)">Close</a>
          </p>
          <p class="control">
            <a :class="{'button': true, 'is-success': true, 'is-disabled': errors.any(), 'is-loading': inProgress}" @click="save">Save</a>
          </p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
  import { Validator } from 'vee-validate'
  import vSelect from 'vue-select'
  import { cnpj } from 'vee-cpf-cnpj'
  import 'vue-select/dist/vue-select.css'
  import _ from 'lodash'
  // extend('cnpj', cnpj);

  Validator.extend('cnpj', cnpj)

  // let instance = new Validator({ trueField: 'truthy' })

  // // Also there is an instance 'extend' method for convenience.
  // instance.extend('cnpj', (value) => !value)

  // instance.attach({
  //   name: 'falseField',
  //   rules: 'cnpj'
  // })

  export default {
    props: {
      context: {
        type: Object
      },
      callback: {
        type: String
      },
      title: {
        type: String
      },
      hotel_id: {
        type: Number
      }
    },
    data () {
      return {
        hotel: {
          id: '',
          name: '',
          address: '',
          email: '',
          social_reason: '',
          cnpj: '',
          card_statement_name: '',
          financial_email: '',
          receipt_email: '',
          phone: '',
          api_hotel_id: '',
          chain_id: '',
          chain_name: '',
          country: {
            name: ''
          },
          payment_information: '',
          markup: 0.0
        },
        chain: {
          id: null,
          name: ''
        },
        chain_hotel: {
          id: null,
          name: ''
        },
        chains: [],
        chains_hotel: [],
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        if (this.hotel_id) {
          this.loadData()
        } else {
          document.body.appendChild(this.$el)
        }
      })
    },
    methods: {
      close (closeOnly, result) {
        if (!closeOnly) {
          this.context[this.callback](result)
        }
        this.$el.remove()
      },
      getChains: _.debounce(function (search, loading) {
        if (search.length) {
          loading(true)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/chains/all', { params: {'query': search}
          }).then(response => {
            this.chains = response.body
            loading(false)
          })
        }
      }, 500),
      getChainsHotel: _.debounce(function (search, loading) {
        if (search.length) {
          loading(true)
          this.context.$http.get(this.context.$store.state.config.apiURL + '/chains_hotel/all', { params: {'query': search}
          }).then(response => {
            this.chains_hotel = response.body
            loading(false)
          })
        }
      }, 500),
      save () {
        this.$validator.validateAll().then(() => {
          if (this.errors.items.length === 0) {
            this.inProgress = true
            this.error = ''
            if (this.chain) {
              this.hotel.chain_id = this.chain.id
            } else {
              this.hotel.chain_id = null
            }
            if (this.chain_hotel) {
              this.hotel.chain_hotel_id = this.chain_hotel.id
            } else {
              this.hotel.chain_hotel_id = null
            }
            let url = this.context.$store.state.config.apiURL + '/hotels/' + this.hotel_id
            this.context.$http.post(url, this.hotel).then((response) => {
              this.inProgress = false
              this.close(false, {ok: true, message: 'The hotel ' + response.body.name + ' was successfully save'})
            }, (response) => {
              this.inProgress = false
              this.error = response.body
            })
          }
        })
      },
      loadData () {
        this.context.$http.get(this.context.$store.state.config.apiURL + '/hotels/' + this.hotel_id).then((response) => {
          this.hotel = response.body
          if (response.body.cnpj) {
            this.hotel.cnpj = response.body.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
          }
          if (response.body.chain !== null) {
            this.chain.name = response.body.chain.name
            this.chain.id = response.body.chain.id
          }
          if (response.body.chain_hotel_id !== null) {
            this.chain_hotel.name = response.body.chain_hotel.name
            this.chain_hotel.id = response.body.chain_hotel.id
          }
          document.body.appendChild(this.$el)
        }, (response) => {
        })
      }
    },
    components: {
      vSelect
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },
      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  .panel {
    background-color: white;
    box-shadow: 0px 2px 3px rgb(167, 28, 32), 0px 0px 0px 1px rgb(167, 28, 32);
    color: #4a4a4a;
    max-width: 100%;
    position: relative;
    border: 0px;
    border-radius: 0px;
  }

  .panel-heading {
    color: #FFFFFF;
    font-weight: bold;
    -ms-flex-align: stretch;
    align-items: stretch;
    display: -ms-flexbox;
    display: flex;
    min-height: 40px;
    box-shadow: 0px 1px 0px rgb(167, 28, 32), 0px 0px 0px 0px rgb(167, 28, 32);
    background-color: rgb(167, 28, 32);
    border-bottom: 0px;
    border-radius: 0px;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// Hotel.vue?057fdbd5